import type {AlpineComponent} from 'alpinejs';

type PageFilterData = {
  teasers: HTMLElement[]; // Arrays aller Teaser-Divs
  filters: Set<string>;
  itemsPerLoad: number;
  currentIndex: number;
  init: () => void;
  toggleFilter: (event: Event) => void; //bei Klick auf Kategorie ausgelöst
  showNext: () => void;
  updateDisplay: () => void;
};

export default (): AlpineComponent<PageFilterData> => ({
  teasers: [],
  filters: new Set(),
  itemsPerLoad: 8,
  currentIndex: 0,

  init() {
    // Teaser-Divs
    this.teasers = Array.from(
      document.querySelectorAll<HTMLElement>('[data-js="teaser-wrapper"]')
    );

    // Filter
    document
      .querySelectorAll<HTMLElement>('[data-category]')
      .forEach(btn =>
        btn.addEventListener('click', e => this.toggleFilter(e))
      );

    //Show more Button
    document
      .getElementById('load-more')
      ?.addEventListener('click', () => this.showNext());

    // Erste Anzeige
    this.updateDisplay();
  },

  toggleFilter(event: Event) {
    const btn = event.currentTarget as HTMLElement;
    const category = btn.dataset.category;
    if (!category) return;

    if (this.filters.has(category)) {
      this.filters.delete(category);
      btn.classList.remove('active');
    } else {
      this.filters.add(category);
      btn.classList.add('active');
    }

    this.currentIndex = 0;
    this.updateDisplay();
  },

  showNext() {
    this.currentIndex += this.itemsPerLoad;
    this.updateDisplay();
  },

  updateDisplay() {
    let visibleCount = 0;
    let matchedCount = 0;

    this.teasers.forEach(wrapper => {
      const teaser = wrapper.querySelector<HTMLElement>('[data-js="teaser"]');
      if (!teaser) return;

      const categories = wrapper.dataset.categories?.split(',') ?? [];
      const match =
        this.filters.size === 0 ||
        categories.some(c => this.filters.has(c));

      if (match) {
        matchedCount++;

        if (visibleCount < this.currentIndex + this.itemsPerLoad) {
          // sichtbar lassen
          teaser.classList.remove('is-hidden');
          wrapper?.classList.remove('is-hidden');

          visibleCount++;
        } else {
          // Pagination-Limit erreicht
          teaser.classList.add('is-hidden');
          setTimeout(() => {
            wrapper?.classList.add('is-hidden');
          }, 200);
        }
      } else {
        // kein Match
        teaser.classList.add('is-hidden');
        setTimeout(() => {
          wrapper?.classList.add('is-hidden');
        }, 200);
      }
    });

    // Show-more Button
    const loadMore = document.getElementById('load-more');
    if (loadMore) {
      loadMore.style.display =
        visibleCount < matchedCount ? 'block' : 'none';
    }
  }
});
